export const PRIMARY_COLOR = '#221CB6';
export const GREY_LIGHT_COLOR = '#DBDFE7';
export const GREY_COLOR = '#C1C1C1';

export const LIGHT_MAIN_COLOR = '#EEF3FF';
export const PRIMARY_BLACK_COLOR = '#000000';
export const SECONDARY_BLACK_COLOR = '#181818';

export const MEDIUM_GREY_COLOR_FOR_ICONS = '#7B7B7B';
export const LIGHT_GREY_COLOR_FOR_ICONS = '#D1D1D1';

export const ERROR_MESSAGE = '#FF6868';
export const DANGER_COLOR = '#ed483d';
// Matches $success-color in src/vendors/colors.scss
export const SUCCESS_COLOR = '#23E771';
// Matches $warning-bg-color in src/vendors/colors.scss
export const WARNING_COLOR = '#FC8E0E';
export const WARNING_LIGHT_BG_COLOR = '#FFF1E2';
export const WHITE_COLOR = '#FFFFFF';

// Status pills of an item that is not live yet (Concierge "Draft" campaigns, Publisher
// "Draft" websites): grey text on a near-white background.
export const DRAFT_BG_COLOR = '#F5F6FA';
export const DRAFT_TEXT_COLOR = '#A3B2C9';

export const OrderPricing = {
  0: 'red',
  1: 'yellow',
  2: 'light-green',
  3: 'bright-green',
  4: 'dark-green',
};

export const OrderLevel = {
  0: 'Starter',
  1: 'Standard',
  2: 'Authority',
  3: 'Power',
  4: 'Elite',
};
